Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "DropdownContent3084812369",
  {"root":"DropdownContent3084812369--root","optionsContainer":"DropdownContent3084812369--optionsContainer","dropdownOption":"DropdownContent3084812369--dropdownOption"},
  ".DropdownContent3084812369--root{outline:0}.DropdownContent3084812369--optionsContainer{outline:0;overflow:auto;max-height:260px;position:relative}",
  2,
  "DropdownContent3084812369"
);
__webpack_require__.stylable.$.register(exports.default)
